import { all, fork } from 'redux-saga/effects';
// redux
import * as W from './watchers';

export function* inventorySaga() {
  yield all([fork(W.watchGetInventory), fork(W.watchInventoryPdf)]);
}
